<template>
  <ModalPodcastLayout :closeModal="closeEmbedModal">
    <div class="embed-container">
      <div class="iframe-links pt-0">
        <div class="iframe-container sm:p-2 sm:grid sm:grid-cols-12">
          <div class="col-span-2 embed-title">{{ $t('player.link') }}</div>
          <div class="col-span-9 flex share-text">
            <textarea id="text-to-copy" v-html="pageURL"></textarea>
            <button
              @click="copyToClipboard(pageURL)"
              v-html="textContent === pageURL ? SVG.DONE : SVG.COPY"
            />
          </div>
        </div>
        <div class="iframe-container sm:p-2 sm:grid sm:grid-cols-12">
          <div class="col-span-2 embed-title">{{ $t('AllTraslation.embedCode') }}</div>
          <div class="col-span-9 flex share-text">
            <textarea id="text-to-copy" v-html="information"></textarea>
            <button
              @click="copyToClipboard(information)"
              v-html="textContent === information ? SVG.DONE : SVG.COPY"
            />
          </div>
        </div>
      </div>
      <div class="bottom-controls share-modal sm:p-1">
        <ShareNetwork
          network="facebook"
          :url="pageURL"
          :title="audioInfos.audioTitle"
          :description="audioInfos.desc"
          v-html="SVG.FB"
        >
        </ShareNetwork>
        <ShareNetwork
          network="linkedin"
          :url="pageURL"
          :title="audioInfos.audioTitle"
          :description="audioInfos.desc"
          v-html="SVG.LINKEDIN"
        >
        </ShareNetwork>
        <ShareNetwork
          network="twitter"
          :url="pageURL"
          :title="audioInfos.audioTitle"
          :description="audioInfos.desc"
          v-html="SVG.TWITTER"
        >
        </ShareNetwork>
        <ShareNetwork
          network="email"
          :url="pageURL"
          :title="audioInfos.audioTitle"
          :description="audioInfos.desc"
          v-html="SVG.MAIL">
      </ShareNetwork>
      </div>
    </div>
  </ModalPodcastLayout>
</template>

<script>
import ModalPodcastLayout from "../../layout/ModalPodcastLayout/ModalPodcastLayout.vue";
import { SVG } from "../../utils/const";
import en from '../../../i18n/en_US'
import fr from '../../../i18n/fr_FR'

import { defineComponent } from "vue";

export default defineComponent({
  name: "video-embed",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {
    ModalPodcastLayout,
  },
  props: {
    information: {
      type: String,
      required: true,
    },
    closeEmbedModal: {
      type: Function,
    },
    audioInfos: {
      type: Object,
      required: true,
    },
    pageURL: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      textContent: "",
      SVG,
    };
  },
  methods: {
    async copyToClipboard(stringToCopy) {
      try {
        await navigator.clipboard.writeText(stringToCopy);
        console.log("Text copied to clipboard");
        this.textContent = stringToCopy;
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    },
  },
});
</script>

<style>
@import "./EmbedModal.css";
</style>
